import type { DeviceAlertsResourceReadApi } from '@ingenico/api-sdk-device-management-private-v2';
import type { DeviceAlerts } from '../../../model/deviceAlerts.model';
import { toIsoStringIfDate } from '../utils/date.utils';

export function checkShouldEnableDeviceAlertsByRule(data?: DeviceAlertsResourceReadApi): boolean {
  return data?.geofencingArea?.enablement === 'ENABLED' && data?.geofencingArea?.status === 'STARTED';
}

export function mapGetDeviceAlertsResponse(response: DeviceAlertsResourceReadApi): DeviceAlerts {
  return {
    sinceDate: toIsoStringIfDate(response.geofencingArea?.updateDate),
    areas: response.geofencingArea?.areas ?? [],
    enablement: response.geofencingArea?.enablement,
    status: response.geofencingArea?.status,
    isEnabled: checkShouldEnableDeviceAlertsByRule(response),
  };
}
